import React from 'react'
import TextField from "@material-ui/core/TextField";
import {Chip, FormLabel} from "@material-ui/core";
import globalTheme from '../theme/globalTheme'

/**
 * Final FormプラグインとMaterial UI Formフィールドを結合するコンポーネント
 * final formの入力フェルド
 *
 * @param {string} name - テキストフィールドの名前
 * @param {*} onChange - テキスト変更イベント
 * @param {string} value - テキスト値
 * @param {number} multiline - テキストエリアの行数
 * @param {*} restInput - 他の属性
 * @param {Object} meta - final formメタ情報
 * @param loadingOnDisable - ロード中の状態
 * @param {*} rest - 他の属性
 * @returns {JSX.Element}
 */
const FinalFormTextField = ({
                                input: {name, onChange, value, multiline = 0, ...restInput},
                                meta,
                                loadingOnDisable,
                                ...rest
                            }) => {
    const classes = globalTheme.defaultFormStyle();
    const loadOnDisable = loadingOnDisable && rest.disabled ? classes.loadingOnDisable : undefined
    let style = {};
    if(rest?.noBold === true) {
        style = {fontWeight: 300}
    }
    return (
        <div>
            <FormLabel className={loadOnDisable} style={style}>
                {rest.label}
                {rest.required &&
                <Chip label={"必須"} size="small" className={[classes.chip, loadOnDisable].join(" ") }/>
                }
            </FormLabel>
            <TextField
                className={[classes.textfield, loadOnDisable].join(" ")}
                {...rest}
                name={name}
                data-testid={name}
                onKeyPress={e => {e.key === "Enter" && e.preventDefault()}}
                variant="outlined"
                multiline={(multiline > 0)}
                disabled={rest.disabled}
                rows={multiline}
                helperText={meta.touched ? (meta.error || meta.submitError)  : undefined}
                error={(meta.error || meta.submitError ) && meta.touched}
                inputProps={restInput}
                onChange={onChange}
                value={value}
                label=""
            />
        </div>)
}
export default FinalFormTextField;
